var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-template-provider',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var $templateData = ref.$templateData;
return [(!!$templateData.body)?[_c('div',{staticClass:"u-express-trust-content"},[_c('u-markdown',{staticClass:"preview"},[_vm._v(_vm._s($templateData.body))])],1)]:_vm._e()]}}])},'client-template-provider',_vm.basketSummaryFooterProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }